import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { SessionService } from '../services/session.service';
import { MenuConfig } from '../entities/configs/menu.config';
import { AppConfig } from '../entities/configs/app.config';
import { User } from '../entities/apis/user';

@Component({
  selector: 'index-root',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.css']
})
export class IndexComponent implements OnInit {
  isCollapsed = true;
  appConfig!: AppConfig;
  menus!: MenuConfig[];
  user!: User;

  constructor(private sessionService: SessionService, private router: Router) { }

  ngOnInit() {
    this.appConfig = this.sessionService.appConfig;
    this.menus = this.sessionService.menus;
    if (this.sessionService.user) {
      this.user = this.sessionService.user;
    } else {
      this.logout();
    }
  }

  logout() {
    this.router.navigate(['login']);
    this.sessionService.user = null;
  }
}
